// ============================================
// A/B Testing Configuration
// ============================================

const AB_TEST_CONFIG = {
  variants: {
    long: {
      formClass: 'klaviyo-form-WTx5TD',
      pdfUrl:
        'https://cdn.shopify.com/s/files/1/0712/5785/0114/files/5_Silent_Signs_Your_Cells_Are_Running_Out_of_Energ_2.pdf?v=1763489451',
      title: 'Your 70+ Page eBook is Ready!',
    },
    short: {
      formClass: 'klaviyo-form-XTCPiH',
      pdfUrl:
        'https://cdn.shopify.com/s/files/1/0712/5785/0114/files/RBS-LeadMagnet-Ebook-ShortVersion.pdf?v=1763489451',
      title: 'Your 7+ Page eBook is Ready!',
    },
  },
  queryParam: 'variant',
};

// ============================================
// Utility Functions
// ============================================

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function setSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    console.warn('SessionStorage not available:', e);
  }
}

function getSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    console.warn('SessionStorage not available:', e);
    return null;
  }
}

function trackEvent(eventName, properties = {}) {
  if (window.Consentmo && window.Consentmo.analyticsAllowed() === true && typeof gtag !== 'undefined') {
    gtag('event', eventName, properties);
  }

  // Note: window.fbq is usually undefined on RBS (Meta is a Customer Events pixel).
  // NewsletterSignup for Meta goes through Shopify.analytics.publish → custom pixel.
  if (window.Consentmo && window.Consentmo.marketingAllowed() === true && typeof fbq === 'function') {
    fbq('trackCustom', eventName, properties);
  }

  console.log('Event tracked:', eventName, properties);
}

// ============================================
// Main Lead Magnet Page Logic
// ============================================

if (window.location.pathname === '/pages/cells-are-running-out-of-energy') {
  document.body.classList.add('lead-magnet-main');

  let variant = getQueryParam(AB_TEST_CONFIG.queryParam);

  if (!variant || !AB_TEST_CONFIG.variants[variant]) {
    const variantKeys = Object.keys(AB_TEST_CONFIG.variants);
    variant = variantKeys[Math.floor(Math.random() * variantKeys.length)];

    trackEvent('LeadMagnet_VariantRandomized', {
      variant: variant,
      page: 'main',
    });
  }

  setSessionStorage('ab_test_variant', variant);
  document.body.classList.add('variant-' + variant);

  trackEvent('LeadMagnet_PageView', {
    variant: variant,
    page: 'main',
  });

  const checkAndShowForms = () => {
    const longForm = document.querySelector('.klaviyo-form-WTx5TD');
    const shortForm = document.querySelector('.klaviyo-form-XTCPiH');

    if (longForm || shortForm) {
      if (variant === 'long') {
        if (longForm) {
          longForm.style.display = 'block';
          longForm.parentElement.style.display = 'block';
        }
        if (shortForm) {
          shortForm.style.display = 'none';
          shortForm.parentElement.style.display = 'none';
        }
      } else if (variant === 'short') {
        if (longForm) {
          longForm.style.display = 'none';
          longForm.parentElement.style.display = 'none';
        }
        if (shortForm) {
          shortForm.style.display = 'block';
          shortForm.parentElement.style.display = 'block';
        }
      }
    } else {
      setTimeout(checkAndShowForms, 100);
    }
  };

  checkAndShowForms();
  setTimeout(checkAndShowForms, 500);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        const successMessage = document.querySelector(
          '.klaviyo-form-success, [data-testid="success-message"]'
        );
        if (successMessage) {
          trackEvent('LeadMagnet_FormSubmitted', {
            variant: variant,
            page: 'main',
          });
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });


}

// ============================================
// Download Page Logic
// ============================================

if (window.location.pathname === '/pages/cells-are-running-out-of-energy-download') {
  document.body.classList.add('lead-magnet-download');

  let variant = getSessionStorage('ab_test_variant') || 'short';
  const config = AB_TEST_CONFIG.variants[variant];

  trackEvent('LeadMagnet_DownloadPageView', {
    variant: variant,
  });

  document.body.innerHTML =
    `
    <div class="rbsv2-optin__download">
      <div class="rbsv2-optin__download-logo center">
        <img src="https://cdn.shopify.com/s/files/1/0712/5785/0114/files/Renue-by-Science_logo-blue.png?v=1758065240" width="180" height="auto" alt="Renue by Science">
      </div>
      <div class="rbsv2-optin__download-content center">
        <h2><strong>${config.title}</strong></h2>
        <p>Click the button below to open your PDF:</p>
        <button class="rbsv2-optin__download-button" onclick="openPDF()">Open PDF in New Tab</button>
        <p class="rbsv2-optin__download-back"><a href="/pages/cells-are-running-out-of-energy?variant=${variant}">← Back to main page</a></p>
      </div>
    </div>
  `;

  window.openPDF = function () {
    trackEvent('LeadMagnet_PDFOpened', {
      variant: variant,
      method: 'button_click',
    });
    window.open(config.pdfUrl, '_blank');
  };

  setTimeout(() => {
    const newTab = window.open(config.pdfUrl, '_blank');

    if (!newTab || newTab.closed || typeof newTab.closed == 'undefined') {
      document.querySelector('.rbsv2-optin__download-content').innerHTML +=
        '<p style="color: red; margin-top: 20px;">Pop-up blocked! Please click the button above to open your PDF.</p>';
    } else {
      trackEvent('LeadMagnet_PDFOpened', {
        variant: variant,
        method: 'auto_popup',
      });
    }
  }, 500);
}